<script>
/**
 * Contact component
 */
export default {
  name: 'Contact',
//   method:
//   {
//     handleSubmit (event) {
//   event.preventDefault();

//   const myForm = event.target;
//   const formData = new FormData(myForm);
  
//   fetch("/контакти", {
//     method: "POST",
//     headers: { "Content-Type": "application/x-www-form-urlencoded" },
//     body: new URLSearchParams(formData).toString(),
//   })
//     .then(() => console.log("Form successfully submitted"))
//     .catch((error) => alert(error));

//     document
//   .querySelector("form")
//   .addEventListener("submit", handleSubmit);
// },
//   }
  }
</script>

<template>
  <!-- CONTACT FORM START-->
  <section class="section" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Свържете се с нас</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center font-secondary padding-t-30"
          ></p>
        </div>
      </div>
      <!-- <form name="contact" method="POST" data-netlify="true" onSubmit="submit">
  <p>
    <label>Your Name: <input type="text" name="name" /></label>
  </p>
  <p>
    <label>Your Email: <input type="email" name="email" /></label>
  </p>
  <p>
    <label>Your Role: <select name="role[]" multiple>
      <option value="leader">Leader</option>
      <option value="follower">Follower</option>
    </select></label>
  </p>
  <p>
    <label>Message: <textarea name="message"></textarea></label>
  </p>
  <p>
    <button type="submit">Send</button>
  </p>
</form> -->

      <form action=""
      name="contact" method="POST" data-netlify="true"
      >
      <div class="row">
        <div class="col-lg-4">
          <div class="mt-4 pt-4">
       
            <p class="mt-4">
              <span class="h5">Имейл адрес:</span>
              <br />
              <span class="text-muted d-block mt-2">
                tanilieva@mail.bg
              </span>
            </p>
            <p class="mt-4">
              <span class="h5">Телефонен номер: </span>
              <br />
              <span class="text-muted d-block mt-2">+359 889 469 526</span>
            </p>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="custom-form mt-4 pt-4">
            <div id="message"></div>
            <form method="post" action="php/contact.php" name="contact-form" id="contact-form">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="name"
                      id="name"
                      type="text"
                      class="form-control"
                      placeholder="Вашето име*"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="email"
                      id="email"
                      type="email"
                      class="form-control"
                      placeholder="Вашият имейл*"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mt-2">
                    <input
                      type="text"
                      class="form-control"
                      id="subject"
                      placeholder="Вашата тема"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mt-2">
                    <textarea
                      name="comments"
                      id="comments"
                      rows="4"
                      class="form-control"
                      placeholder="Вашето съобщение"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 text-right">
                  <input
                    type="submit"
                    id="submit"
                    name="send"
                    class="submitBnt btn btn-custom"
                    value="Изпрати съобщение"
                  />
                  <div id="simple-msg"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </form>
    </div>
  </section>
  <!-- CONTACT FORM END-->
</template>